let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7oXEX")).then(() => parcelRequire('fCDBD'));